<!-- <div *ngIf="!to.ynAsync">
<mat-radio-group required [formControl]="formControl">
  <mat-radio-button class="radio-button" *ngFor="let option of to.options; let first = first; let last = last;"
  [class.radio-button-olaf]="last" [class.radio-button-cyntaf]="first" [value]="option.key"></mat-radio-button>
</mat-radio-group>
</div>

<div *ngIf="to.ynAsync">
  <mat-radio-group required [formControl]="formControl" *ngIf="to.options | async as options">
    <mat-radio-button class="radio-button" *ngFor="let option of options; let first = first; let last = last;"
    [class.radio-button-olaf]="last" [class.radio-button-cyntaf]="first" [value]="option.key"></mat-radio-button>
  </mat-radio-group>
</div> -->

@if (!to.ynAsync) {
  <div>
    <mat-radio-group class="radio-group-flex" required [formControl]="formControl">
      @for (option of to.options; track option) {
        <mat-radio-button class="radio-button" [value]="option.key">
        </mat-radio-button>
      }
    </mat-radio-group>
  </div>
}

@if (to.ynAsync) {
  <div>
    @if (to.options | async; as options) {
      <mat-radio-group class="radio-group-flex" required [formControl]="formControl"
        >
        @for (option of options; track option) {
          <mat-radio-button class="radio-button" [value]="option.key">
          </mat-radio-button>
        }
      </mat-radio-group>
    }
  </div>
}